module.exports = __webpack_public_path__ + "img/maid_cleaning_new1.9c34fb89.jpg";